
import { Card, CardContent } from "@/components/ui/card";

type ReportSectionsProps = {
  sections: string[];
};

const ReportSections = ({ sections }: ReportSectionsProps) => {
  if (sections.length === 0) return null;
  
  return (
    <Card variant="report" className="mb-6">
      <CardContent className="p-0 pt-2">
        <h3 className="text-gray-300 mb-2 text-sm sm:text-base font-medium">Report Sections:</h3>
        <div className="flex flex-wrap gap-1.5 sm:gap-2">
          {sections.map((section, idx) => (
            <span 
              key={idx}
              className="px-2 sm:px-3 py-0.5 sm:py-1 bg-gradient-to-br from-gray-700/80 to-gray-700/50 backdrop-blur-sm rounded-full text-xs sm:text-sm text-gray-200 border border-gray-600/20 shadow-sm hover:shadow-md transition-all cursor-default"
            >
              {section}
            </span>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default ReportSections;
